import { render, staticRenderFns } from "./overlay-interstitial-content.vue?vue&type=template&id=2124d369&"
import script from "./overlay-interstitial-content.vue?vue&type=script&lang=js&"
export * from "./overlay-interstitial-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports